const regExp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;

export function checkEmail(email: string): boolean {
  return regExp.test(email);
}

export function getFirstPart(email: string): string {
  const atIndex = email.indexOf("@");
  return atIndex > 0 ? email.substring(0, atIndex) : "";
}
